// components
import Collapse from "@/components/Collapse";

// interfaces
import { IFAQ } from "@/types/Global";

// assets
import styles from "@/assets/styles/pages/location-single-page/index.module.scss";

const LocationFAQ = ({ faqList }: { faqList: IFAQ[] }) => {

  if (!faqList.length) {
    return null;
  }

  return (
    <div className={styles["locl-location-faq"]}>
      <div className={styles["locl-location-faq__title"]}>
        Frequently Asked Questions
      </div>
      <Collapse>
        {
          faqList.map((faq, index) => (
            <Collapse.Panel
              header={faq.question}
              key={index}
              className={styles["locl-location-faq__block"]}
              showArrow
            >
              <p className={styles["locl-location-faq__answer"]}>{faq.answer}</p>
            </Collapse.Panel>
          ))
        }
      </Collapse>
    </div>
  )
}

export default LocationFAQ;
